<script>
import moment from "moment";
import CandidateOverviewModal from './Applicant/CandidateOverviewModal.vue'

export default {
    components: {
        CandidateOverviewModal
    },
    data() {
        return {
            isPopupOpen: false,
            isPopupMatricOpen: false,
            hasMatric: false,
            matricDetails: {},
            backgroundVerificationFailCount: 0,
            unavailableCount: 0,
            notShowingUpCount: 0,
            previousRejectionsCount: 0,
            recycleCount: 0
        }
    },
    props: {
        jobApplication: {
            type: Object,
            required: true
        },
        requisition: {
            type: Object,
            required: true
        },
        phase: {
            type: String,
            required: true
        },
        selectedApplications: {
            type: Array,
            required: false
        },
        bulkRecycle:{
            type: String,
            required: false,
            default: ''
        }
    },
    computed: {
        createdDate() {
            return moment(new Date(this.jobApplication.created)).format("YYYY-MM-DD")
        },
        updatedDate() {
            return moment(new Date(this.jobApplication.modified)).format("YYYY-MM-DD HH:mm")
        },
        isSelected() {
            return this.selectedApplications.some(selectedUserId => selectedUserId === this.jobApplication.id);
        },
        previousRejectionTitle() {
            if (this.jobApplication.previous_failed_job_application === null || this.jobApplication.previous_failed_job_application === undefined) {
                return '';
            }

            const reason = (this.jobApplication.previous_failed_job_application 
                && this.jobApplication.previous_failed_job_application.fail_reason 
                && this.jobApplication.previous_failed_job_application.fail_reason.length > 0 
                && this.jobApplication.previous_failed_job_application.fail_reason !== 'null') 
                ? this.jobApplication.previous_failed_job_application.fail_reason 
                : '';

            const requisitionTitle = (this.jobApplication.previous_failed_job_application.job !== undefined) ? this.jobApplication.previous_failed_job_application.job.title : '';
            const requisitionNumber = (this.jobApplication.previous_failed_job_application.job !== undefined) ? this.jobApplication.previous_failed_job_application.job.requisition_id : '';

            return `Previous rejections: ${reason}. (${requisitionTitle} - #${requisitionNumber})`;
        }
    },
    methods: {
        openPopup() {
            this.isPopupOpen = true;
        },
        closePopup() {
            this.isPopupOpen = false;
        },
        isPDF(path) {
            return path.toLowerCase().endsWith('.pdf');
        },
        updateSelectedApplication (event){
            const checked = event.target.checked;
            const id = event.target.value;
            this.$emit('update-selected-applications', {
                checked: checked,
                id: id,
                phase: this.phase
            })
        },
        toggleModal(ref) {
            this.$refs[ref].toggleModal()
        },

    },
    mounted() {
        if (this.jobApplication.user.user_detail !== null) {
            this.jobApplication.user.user_detail.qualifications.forEach(qualification => {
                if (qualification.matric_certificate_number) {
                    this.hasMatric = true;
                    this.matricDetails = qualification;
                    return;
                }
            });
        }
        if (this.jobApplication.job_application_actions !== null) {
            this.jobApplication.job_application_actions.forEach(action => {
                if (action.step === 'background_verification' && action.action === 'failed') {
                    this.backgroundVerificationFailCount++;
                }
                if (action.step === 'telephonic_screening' || action.step === 'first_interview' || action.step === 'panel_interview') {
                    if (action.action === 'failed') {
                        this.unavailableCount++;
                    }
                }
                if (action.step === 'onboarding' || action.step === 'start') {
                    if (action.action === 'failed') {
                        this.notShowingUpCount++;
                    }
                }
                if (action.action === 'failed') {
                    this.previousRejectionsCount++;
                }
                if (action.action === 'recycled') {
                    this.recycleCount++;
                }
            });
        }
    }
}
</script>

<template>
        <div
            class="applicant-link"
            :class="{
                'red-background':
                    jobApplication.killer_question_auto_failed == true
            }"
        >
        <a target="_blank" class="box" :href="`/recruiter/active-requisitions/applicant/${jobApplication.id}#${phase}`">
            <strong class="name">{{ jobApplication.user.full_name }}</strong>
            <div class="date text-center">ID: {{ jobApplication.user.id_number }}</div>
            <div class="date text-center" v-if="jobApplication.user.user_detail.user_detail_jobs[0] && jobApplication.user.user_detail.user_detail_jobs[0].role">
                {{ jobApplication.user.user_detail.user_detail_jobs[0].role.title }}
            </div>

            <div class="date text-center">Applied: {{ createdDate }}</div>
        </a>
        <div class="text-center candidate-overview-info">
            <a @click="toggleModal(`candidateOverviewModal${jobApplication.id}`)">
                Candidate Overview
            </a>
        </div>

        <candidate-overview-modal :ref="`candidateOverviewModal${jobApplication.id}`" :job-application="jobApplication" :csrf-token="csrfToken" />

        <div v-if="jobApplication.user.id_path" class="documents icon">
            <a @click.prevent="openPopup" href="#" class="documents icon">
                <i class="fa-regular fa-id-card" title="ID Document"></i>
            </a>
        </div>
        <div v-if="isPopupOpen" class="popup">
            <div class="popup-content">
                <i class="fa-solid fa-times close-icon" @click="closePopup"></i>
                <div v-if="isPDF(jobApplication.user.id_path)">
                    <iframe :src="jobApplication.user.id_path_cdn" width="1000px" height="600px"></iframe>
                </div>
                <div v-else>
                    <div class="image-popup" :style="{'background-image':`url(${jobApplication.user.id_path_cdn})`}"></div>
                    <a class="btn btn-success" :href="jobApplication.user.id_path_cdn" target="_blank">Download Image</a>
                </div>
            </div>
        </div>
        <div v-if="hasMatric" @click="isPopupMatricOpen = true" class="documents icon">
            <i class="fa-solid fa-graduation-cap" title="Matric Qualification"></i>
        </div>
        <div v-if="isPopupMatricOpen" class="popup">
            <div class="popup-content">
                <i class="fa-solid fa-times close-icon" @click="isPopupMatricOpen = false"></i>
                <div v-if="matricDetails.qualification_documents.length > 0">
                    <div v-if="isPDF(matricDetails.qualification_documents[0].path_cdn)">
                        <iframe :src="matricDetails.qualification_documents[0].path_cdn" width="1000px" height="600px"></iframe>
                    </div>
                    <div v-else>
                        <div class="image-popup" :style="{'background-image':`url(${matricDetails.qualification_documents[0].path_cdn})`}"></div>
                        <a class="btn btn-success" :href="matricDetails.qualification_documents[0].path_cdn" target="_blank">Download Image</a>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="jobApplication.user.user_detail !== null && jobApplication.user.user_detail.user_detail_jobs" class="documents icon">
            <i class="fa-solid fa-briefcase" :title="`${jobApplication.user.cv_details_percent_complete}% CV completed | ${(jobApplication.user.work_experience_complete) ? '100' : '0'}% work experience complete`"></i>
        </div>

        <div v-if="jobApplication.user.sage_sync_status" :title="`Latest Synced Requisition ${jobApplication.user.external_requisition_number !== null ? '(' + jobApplication.user.external_requisition_number + ')' : '' }`" class="documents icon" style="width:12px;height: 12px;padding:0; top:-1px">
            <img src="/img/icons/sage.png" alt="Sage Logo">
        </div>

        <div class="checks">
            <div class="documents icon black">
                <i class="fa-solid fa-user-xmark"
                   :title="'Not Showing Up: ' + notShowingUpCount">
                </i>
                <span v-if="notShowingUpCount > 0"
                      class="notification-count">
                    {{ notShowingUpCount }}
                </span>
            </div>
            <div class="documents icon black" v-if="previousRejectionTitle.length > 0">
                <i class="fa-solid fa-circle-exclamation"
                   :title="previousRejectionTitle">
                </i>
            </div>
            <div class="documents icon black">
                <i class="fa-solid fa-recycle"
                   :title="'Recycles: ' + recycleCount">
                </i>
                <span v-if="recycleCount > 0"
                      class="notification-count">
                    {{ recycleCount }}
                </span>
            </div>
            <div v-if="jobApplication.user.baseline_score" class="documents icon black">
                <i class="fa-solid fa-award"
                   :title="'Baseline Score: ' + jobApplication.user.baseline_score">
                </i>
            </div>

            <div v-if="jobApplication.user.ifact_form !== null" class="documents icon text-danger">
                <i
                    class="fa-solid fa-user-slash"
                    :title="`iFacts Flag: ${jobApplication.user.ifact_form.conviction_details}`"
                >
                </i>
            </div>

            <div v-if="jobApplication.user.sage_log && jobApplication.user.sage_log.level === 'error'" class="documents icon text-danger">
                <i
                    class="fa-solid fa-user-injured"
                    :title="`Failed Sage Sync`"
                >
                </i>
            </div>

            <div v-if="jobApplication.user.currently_working_for_merchant" class="documents icon black">
                <img src="https://www.mycalling.co.za/favicon.ico" class="icon-image" title="Currently working for merchant"/>
            </div>
        </div>
        <div v-if="bulkRecycle != ''" class="select-application">
            <input type="checkbox" title="Select all candidates" :value="jobApplication.id" @change="updateSelectedApplication($event)" :checked="isSelected"/>
        </div>
    </div>
</template>

<style lang="scss">
@import './assets/scss/frontend/base/colour_vars.scss';

.popup {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 5;
}

.red-background {
    background: rgba(255, 0, 0, 0.4) !important;
}

.popup-content {
  background-color: white;
  padding: 20px;
  border-radius: 4px;
  max-width: 90%;
  max-height: 90%;
  position: relative;
}

.close-icon {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  font-size: 20px;
  color: $dark-charcoal;
}

.applicant-link {
    display: block;
    border-radius: 3px;
    border: 1px solid $accordion-item-bg-color;
    background: $off-white;
    padding: 8px 4px;
    text-align: center;
    box-sizing: border-box;
    color: $site-gray;
    text-decoration: none;
    margin-bottom: 10px;

    .box {
        text-decoration: none;
        color: $site-gray;
    }

    .name, .id-number, .documents, .checks {
        display: block;
        margin-left: auto;
        margin-right: auto;
        margin-bottom: 2px;
        width: fit-content;
    }

    .name {
        color: $site-gray;
        font-family: Roboto;
        font-size: 11px;
        font-weight: bold;
        letter-spacing: 0;
        line-height: 12px;
        text-align: center;
    }

    .id-number, .date {
        color: $site-gray;
        font-family: Roboto;
        font-size: 10px;
        letter-spacing: 0;
        line-height: 11px;
        text-align: center;
    }

    .documents {
        span {
        }
    }
    .icon {
        display: inline-block;
        position: relative;
        padding: 1px;
        padding-right: 2px;
        color: $mycalling-green;
        font-size: 12px;
        letter-spacing: 0;
        line-height: 13px;
    }

    .black {
        color: $site-gray;
    }

    .notification-count {
        font-size: 7px;
        color: $white;
        background-color: $red-one;
        padding: 0 4px;
        border-radius: 50%;
        position: absolute;
        top: -6px;
        right: -4px;
    }

    .icon-image {
        width: 12px;
    }
}

.image-popup {
    width: 700px;
    height: 800px;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
}
.candidate-overview-info{
    font-size: 10px;

    a {
        color: $site-green !important;
        text-decoration: underline !important;
    }
}
</style>
